import { Component, OnInit } from '@angular/core';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { GroupValidationBloc } from '@kp/auth/group-validation.bloc';
import { LegalDocumentsBloc } from '@kp/legal-document/legal-documents.bloc';
import { OnboardingBloc } from '@kp/onboarding/onboarding.bloc';
import { DataStoreService, productDisplayName, TitleService } from '@kservice';
import { Status } from '@ktypes/models';

enum ErrorType {
  Default = 'Default',
  PageNotFound = 'PageNotFound',
  GroupNotFound = 'GroupNotFound',
  GuestAccountFailed = 'GuestAccountFailed',
  LegalAcceptanceFailed = 'LegalAcceptanceFailed',
}

@Component({
  selector: 'kp-screen-onboarding-error',
  templateUrl: './screen-onboarding-error.component.html',
  styleUrls: ['./screen-onboarding-error.component.scss'],
})
export class ScreenOnboardingErrorComponent implements OnInit {
  currentErrorType = ErrorType.Default;
  errorType = ErrorType;
  errorText = '';
  productName = productDisplayName;
  private _title = 'Error';

  constructor(
    private _authenticationBloc: AuthenticationBloc,
    public dataStore: DataStoreService,
    private _groupValidationBloc: GroupValidationBloc,
    private _legalDocumentsBloc: LegalDocumentsBloc,
    private _onboardingBloc: OnboardingBloc,
    private _titleService: TitleService
  ) {}

  ngOnInit() {
    const { guestUserDataStatus } = this._onboardingBloc;
    const { groupValidationDataStatus } = this._groupValidationBloc;
    const { serverSideAcceptLegalDocumentsResult } = this._legalDocumentsBloc;

    this._titleService.set(this._title);

    if (this._onboardingBloc.isOnboarding) {
      this._onboardingBloc.setLatestPage('/welcome');
    }

    // If the user manually navigates to any of the /welcome* routes or refreshes the page.
    if (!groupValidationDataStatus) {
      this.currentErrorType = ErrorType.PageNotFound;
      return;
    }

    // The group code entered is invalid.
    if (groupValidationDataStatus?.status === Status.error) {
      this.errorText = groupValidationDataStatus?.data?.groupCode;
      this.currentErrorType = ErrorType.GroupNotFound;
      return;
    }

    // Guest user creation failed.
    if (guestUserDataStatus?.status === Status.error) {
      // e.g. "Guest account creation failed - No remaining licenses."
      this.errorText = guestUserDataStatus.message?.message;
      this.currentErrorType = ErrorType.GuestAccountFailed;
      return;
    }

    // Legal documents failed to be accepted on backend.
    //
    // Note: `false` is an explicit failure, where as `null` is the initial state
    // in which no network request has been made yet.
    if (serverSideAcceptLegalDocumentsResult === false) {
      this.currentErrorType = ErrorType.LegalAcceptanceFailed;
      return;
    }
  }

  clearUserInfo() {
    this._authenticationBloc.resetPaymentRequiredErrorMessage();
    this._authenticationBloc.clearAuthData();
  }
}
